<template>
  <div>
    <!-- 导航栏 -->
    <Nav />

    <!-- 商品详情主体内容 -->
    <!-- 产品图片展示区 -->
    <section class="mt-20 bg-white">
      <div class="max-w-7xl mx-auto px-4 py-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <!-- 左侧图片区 -->
          <div class="space-y-4">
            <div
              class="main-image-container relative overflow-hidden rounded-xl bg-gray-50"
            >
              <img
                id="mainImage"
                :src="currentMainImage || goodsDetail.thumbnail_url"
                class="w-full h-96 object-cover cursor-zoom-in"
                @click="
                  openImageModal(currentMainImage || goodsDetail.thumbnail_url)
                "
              />
              <button
                class="absolute top-4 right-4 w-10 h-10 bg-white bg-opacity-80 rounded-full flex items-center justify-center hover:bg-opacity-100 transition-all"
                @click="
                  openImageModal(currentMainImage || goodsDetail.thumbnail_url)
                "
              >
                <i class="ri-zoom-in-line text-lg text-gray-700"></i>
              </button>
            </div>
            <div class="grid grid-cols-4 gap-3">
              <img
                v-for="(image, index) in goodsDetail.image_urls"
                :key="index"
                :src="image"
                :class="[
                  'w-full h-20 object-cover rounded-lg cursor-pointer border-2',
                  index === activeImageIndex
                    ? 'border-primary thumbnail active'
                    : 'border-transparent thumbnail hover:border-primary',
                ]"
                @click="changeMainImage(image, index, $event)"
              />
            </div>
          </div>

          <!-- 右侧产品信息 -->
          <div class="space-y-6">
            <div class="flex items-start justify-between">
              <div class="flex-1 pr-6">
                <h1 class="text-3xl font-bold text-gray-900 mb-3">
                  {{ goodsDetail.name }}
                </h1>
                <p class="text-gray-600 text-lg leading-relaxed">
                  {{ goodsDetail.full_description }}
                </p>
              </div>
              <button
                @click="toggleFavorite"
                class="p-3 rounded-full transition-colors whitespace-nowrap flex-shrink-0"
                title="收藏设备"
              >
                <i
                  class="text-lg inline-block"
                  :class="
                    isFavorite ? 'ri-heart-fill text-red-500' : 'ri-heart-line'
                  "
                ></i
                ><span class="m-1 inline-block">{{
                  isFavorite ? "已收藏" : "收藏"
                }}</span>
              </button>
            </div>

            <!-- 评分与标签 -->
            <div class="flex items-center space-x-6">
              <div class="flex items-center space-x-2">
                <div class="flex">
                  <i
                    class="ri-star-fill text-yellow-400"
                    v-for="index in this.roundNumber(
                      goodsDetail.star_num,
                      'int'
                    )"
                    :key="index"
                  ></i>
                  <i
                    class="ri-star-line text-gray-300"
                    v-for="index in 5 -
                    this.roundNumber(goodsDetail.star_num, 'int')"
                    :key="index"
                  ></i>
                </div>
                <span class="text-gray-600 text-sm"
                  >{{ goodsDetail.star_num }} 分 </span
                >
              </div>
              <div class="flex space-x-2">
                <span
                  class="bg-blue-50 text-primary px-3 py-1 rounded-full text-sm"
                  >{{ goodsDetail.category_name }}</span
                >
                <span
                  class="bg-green-50 text-green-600 px-3 py-1 rounded-full text-sm"
                  >{{
                    goodsDetail.is_recommend == 1 ? "热门租赁" : "普通租赁"
                  }}</span
                >
              </div>
            </div>

            <!-- 产品特点 -->
            <!-- <div class="grid grid-cols-2 gap-4">
              <div
                class="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"
              >
                <div
                  class="w-8 h-8 bg-primary bg-opacity-10 rounded-full flex items-center justify-center"
                >
                  <i class="ri-hd-line text-primary"></i>
                </div>
                <div>
                  <div class="font-medium text-gray-900">4K 超高清</div>
                  <div class="text-sm text-gray-600">3840×2160 分辨率</div>
                </div>
              </div>
              <div
                class="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"
              >
                <div
                  class="w-8 h-8 bg-primary bg-opacity-10 rounded-full flex items-center justify-center"
                >
                  <i class="ri-sun-line text-primary"></i>
                </div>
                <div>
                  <div class="font-medium text-gray-900">智能调节</div>
                  <div class="text-sm text-gray-600">自动亮度调节</div>
                </div>
              </div>
              <div
                class="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"
              >
                <div
                  class="w-8 h-8 bg-primary bg-opacity-10 rounded-full flex items-center justify-center"
                >
                  <i class="ri-eye-line text-primary"></i>
                </div>
                <div>
                  <div class="font-medium text-gray-900">广视角</div>
                  <div class="text-sm text-gray-600">160° 可视角度</div>
                </div>
              </div>
              <div
                class="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"
              >
                <div
                  class="w-8 h-8 bg-primary bg-opacity-10 rounded-full flex items-center justify-center"
                >
                  <i class="ri-flashlight-line text-primary"></i>
                </div>
                <div>
                  <div class="font-medium text-gray-900">高亮度</div>
                  <div class="text-sm text-gray-600">800cd/㎡ 亮度</div>
                </div>
              </div>
            </div> -->

            <!-- 选择规格 -->
            <div v-for="item in goodsDetail.spec" :key="item.name" class="mb-4">
              <div class="flex flex-wrap items-center">
                <span class="font-medium text-gray-900 mr-3 whitespace-nowrap"
                  >{{ item.name }}：</span
                >
                <!-- 规格值 循环可选择 -->
                <div class="flex flex-wrap items-center gap-2">
                  <span
                    v-for="value in item.values"
                    :key="value"
                    class="px-3 py-1 rounded-full text-md cursor-pointer hover:bg-primary hover:text-white transition-colors"
                    :class="{
                      'bg-primary text-white':
                        selectedSpec[item.name] === value,
                      'bg-gray-100 text-gray-600':
                        selectedSpec[item.name] !== value,
                    }"
                    @click="handleSpecChange(item.name, value)"
                  >
                    {{ value }}
                  </span>
                </div>
              </div>
            </div>

            <!-- 价格与租期 -->
            <div class="bg-blue-50 p-6 rounded-xl">
              <div class="flex items-center justify-between">
                <div>
                  <span class="text-md text-primary">¥</span>
                  <span class="text-3xl font-bold text-primary">{{
                    getCurrentPrice()
                  }}</span>

                  <span class="text-gray-600 ml-2">/天</span>
                </div>
                <span
                  class="bg-red-500 text-white px-3 py-1 rounded-full text-sm"
                  >限时优惠</span
                >
              </div>
            </div>

            <!-- 数量选择 -->
            <div>
              <label class="block text-sm font-medium text-gray-900 mb-3"
                >选择数量</label
              >
              <div class="flex items-center space-x-4">
                <button
                  class="w-10 h-10 border-2 border-gray-200 rounded-lg flex items-center justify-center hover:border-primary transition-colors"
                  @click="decreaseQuantity"
                  :disabled="quantity <= 1"
                >
                  -
                </button>
                <input
                  type="number"
                  class="w-20 h-10 border-2 border-gray-200 rounded-lg flex items-center justify-center text-lg font-medium text-center focus:outline-none focus:border-primary dealnumber"
                  v-model="quantity"
                  min="1"
                  max="999"
                  @input="handleQuantityInput"
                />
                <button
                  class="w-10 h-10 border-2 border-gray-200 rounded-lg flex items-center justify-center hover:border-primary transition-colors"
                  @click="increaseQuantity"
                >
                  +
                </button>
                <button
                  class="flex-1 bg-gray-100 text-gray-700 py-3 px-6 !rounded-button hover:bg-gray-200 transition-colors flex items-center justify-center space-x-2 whitespace-nowrap"
                  @click="handleAddToCart"
                >
                  <i class="ri-shopping-cart-line"></i>
                  <span>加入购物车</span>
                </button>
                <button
                  class="flex-1 bg-primary text-white py-3 px-6 !rounded-button hover:bg-secondary transition-colors flex items-center justify-center space-x-2 whitespace-nowrap"
                  @click="handleRentNow"
                >
                  <i class="ri-calendar-check-line"></i>
                  <span>立即租赁</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 详情 -->
    <section class="py-12 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4">
        <h2 class="text-2xl font-bold text-gray-900 mb-8">设备详情</h2>
        <div class="bg-white rounded-xl shadow-sm overflow-hidden">
          <div class="p-8">
            <div
              class="prose max-w-none text-md leading-relaxed"
              v-html="goodsDetail.content"
            ></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务说明 -->
    <section class="py-12">
      <div class="max-w-7xl mx-auto px-4">
        <h2 class="text-2xl font-bold text-gray-900 mb-8">配送安装服务</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div class="text-center p-6">
            <div
              class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4"
            >
              <i class="ri-truck-line text-2xl text-primary"></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">免费配送</h3>
            <p class="text-gray-600 text-sm">
              北京五环内免费配送，其他地区根据距离收取合理运费
            </p>
          </div>
          <div class="text-center p-6">
            <div
              class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4"
            >
              <i class="ri-tools-line text-2xl text-primary"></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">专业安装</h3>
            <p class="text-gray-600 text-sm">
              专业技术团队现场安装调试，确保设备正常运行
            </p>
          </div>
          <div class="text-center p-6">
            <div
              class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4"
            >
              <i class="ri-customer-service-line text-2xl text-primary"></i>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2">技术支持</h3>
            <p class="text-gray-600 text-sm">
              租期内提供 7×24 小时技术支持服务
            </p>
          </div>
        </div>

        <div class="mt-12 bg-blue-50 rounded-xl p-8">
          <h3 class="text-xl font-semibold text-gray-900 mb-6">服务保障</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="flex items-start space-x-3">
              <div class="w-6 h-6 flex items-center justify-center mt-0.5">
                <i class="ri-shield-check-line text-primary"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">品质保证</h4>
                <p class="text-gray-600 text-sm">
                  所有设备均经过严格检测，确保正常使用
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="w-6 h-6 flex items-center justify-center mt-0.5">
                <i class="ri-time-line text-primary"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">准时交付</h4>
                <p class="text-gray-600 text-sm">
                  承诺按时交付，延误赔偿相应损失
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="w-6 h-6 flex items-center justify-center mt-0.5">
                <i class="ri-refresh-line text-primary"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">故障替换</h4>
                <p class="text-gray-600 text-sm">
                  设备故障 2 小时内提供备用设备
                </p>
              </div>
            </div>
            <div class="flex items-start space-x-3">
              <div class="w-6 h-6 flex items-center justify-center mt-0.5">
                <i class="ri-money-dollar-circle-line text-primary"></i>
              </div>
              <div>
                <h4 class="font-medium text-gray-900 mb-1">价格透明</h4>
                <p class="text-gray-600 text-sm">明码标价，无隐藏费用</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 相关配件推荐 -->
    <section class="py-12 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4">
        <h2 class="text-2xl font-bold text-gray-900 mb-8">相关配件推荐</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div
            class="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20LED%20display%20controller%20and%20video%20processor%2C%20modern%20control%20equipment%20with%20clean%20background&width=300&height=200&seq=accessory1&orientation=landscape"
              alt="视频处理器"
              class="w-full h-40 object-cover"
            />
            <div class="p-4">
              <h3 class="font-semibold text-gray-900 mb-2">专业视频处理器</h3>
              <p class="text-gray-600 text-sm mb-3">
                支持多种信号输入，画面处理更流畅
              </p>
              <div class="flex items-center justify-between">
                <span class="text-lg font-bold text-primary">¥150/天</span>
                <button
                  class="bg-primary text-white px-3 py-1.5 !rounded-button text-sm hover:bg-secondary transition-colors whitespace-nowrap"
                >
                  添加
                </button>
              </div>
            </div>
          </div>
          <div
            class="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20audio%20mixer%20and%20sound%20system%20for%20events%2C%20modern%20audio%20equipment%20with%20studio%20background&width=300&height=200&seq=accessory2&orientation=landscape"
              alt="音响系统"
              class="w-full h-40 object-cover"
            />
            <div class="p-4">
              <h3 class="font-semibold text-gray-900 mb-2">专业音响系统</h3>
              <p class="text-gray-600 text-sm mb-3">
                高保真音质，完美配合视频展示
              </p>
              <div class="flex items-center justify-between">
                <span class="text-lg font-bold text-primary">¥300/天</span>
                <button
                  class="bg-primary text-white px-3 py-1.5 !rounded-button text-sm hover:bg-secondary transition-colors whitespace-nowrap"
                >
                  添加
                </button>
              </div>
            </div>
          </div>
          <div
            class="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20stage%20lighting%20equipment%20with%20LED%20spotlights%2C%20modern%20event%20lighting%20system&width=300&height=200&seq=accessory3&orientation=landscape"
              alt="灯光设备"
              class="w-full h-40 object-cover"
            />
            <div class="p-4">
              <h3 class="font-semibold text-gray-900 mb-2">舞台灯光设备</h3>
              <p class="text-gray-600 text-sm mb-3">
                营造完美展示氛围，提升视觉效果
              </p>
              <div class="flex items-center justify-between">
                <span class="text-lg font-bold text-primary">¥200/天</span>
                <button
                  class="bg-primary text-white px-3 py-1.5 !rounded-button text-sm hover:bg-secondary transition-colors whitespace-nowrap"
                >
                  添加
                </button>
              </div>
            </div>
          </div>
          <div
            class="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20truss%20system%20and%20mounting%20hardware%20for%20LED%20displays%2C%20exhibition%20support%20structure&width=300&height=200&seq=accessory4&orientation=landscape"
              alt="支架系统"
              class="w-full h-40 object-cover"
            />
            <div class="p-4">
              <h3 class="font-semibold text-gray-900 mb-2">专业支架系统</h3>
              <p class="text-gray-600 text-sm mb-3">
                稳固可靠的安装支架，多角度调节
              </p>
              <div class="flex items-center justify-between">
                <span class="text-lg font-bold text-primary">¥100/天</span>
                <button
                  class="bg-primary text-white px-3 py-1.5 !rounded-button text-sm hover:bg-secondary transition-colors whitespace-nowrap"
                >
                  添加
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 图片预览模态框 -->
    <div
      id="imageModal"
      class="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4"
      v-if="showPreview"
    >
      <div class="relative max-w-4xl max-h-full">
        <button
          @click="closeImageModal()"
          class="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
        >
          <i class="ri-close-line text-2xl"></i>
        </button>
        <img
          id="modalImage"
          :src="previewImageUrl"
          :alt="goodsDetail.name || ''"
          class="max-w-full max-h-full object-contain"
        />
      </div>
    </div>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import { Message } from "element-ui";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import api from "@/utils/api.js";
import { roundNumber } from "@/utils/tool.js";

export default {
  name: "GoodsDetail",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      goodsDetail: null,
      loading: true,
      error: "",
      quantity: 1,
      showPreview: false,
      previewImageUrl: "",
      activeImageIndex: 0,
      imageList: [],
      currentMainImage: "",
      isFavorite: false,
      selectedSpec: {},
      skuList: [], // SKU数据列表
      currentSku: null, // 当前选中的SKU
    };
  },
  mounted() {
    this.loadGoodsDetail();
  },
  methods: {
    // 切换收藏状态
    async toggleFavorite() {
      try {
        const goodsId = this.$route.params.id;
        const data = { goods_id: goodsId };

        if (this.isFavorite) {
          // 取消收藏
          // 注意：API中没有直接的取消收藏方法，这里假设后端支持通过相同接口处理
          await api.goods.addToFavorite(data);
          this.isFavorite = false;
          Message({ message: "已取消收藏", type: "success" });
        } else {
          // 添加收藏
          await api.goods.addToFavorite(data);
          this.isFavorite = true;
          Message({ message: "已添加到收藏", type: "success" });
        }
      } catch (error) {
        // 如果请求失败，恢复之前的状态
        this.isFavorite = !this.isFavorite;
        console.error("收藏操作失败:", error);
      }
    },

    // 获取设备详情
    async loadGoodsDetail() {
      try {
        this.loading = true;
        this.error = "";
        const goodsId = this.$route.params.id; // 默认使用路由参数作为商品ID
        const response = await api.goods.getDetail({ id: goodsId });
        this.goodsDetail = response.data;
        this.isFavorite = this.goodsDetail.is_favorite;

        // 初始化SKU数据
        this.initSkuData();

        // 初始化图片列表
        // this.imageList = this.goodsDetail.images_urls || [];
        // 检查用户是否已登录
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo && this.goodsDetail) {
          // 这里应该调用获取收藏状态的API，但由于API中没有提供，暂时不实现
          // 实际项目中应该添加一个API来获取用户对当前商品的收藏状态
          // 例如：await this.checkFavoriteStatus(goodsId);
        }

        // 设置页面标题为设备名称
        if (this.goodsDetail && this.goodsDetail.name) {
          document.title = `${this.goodsDetail.name} - 会找我-专业会展设备租赁服务`;
        }
        if (!this.goodsDetail) {
          this.$router.push("/not-found");
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },

    // 初始化SKU数据和默认规格选择
    initSkuData() {
      // 检查是否有规格数据
      if (
        this.goodsDetail &&
        this.goodsDetail.spec &&
        this.goodsDetail.spec.length > 0
      ) {
        // 清空之前的选择
        this.selectedSpec = {};

        // 为每个规格选择第一个值作为默认值
        this.goodsDetail.spec.forEach((spec) => {
          if (spec.values && spec.values.length > 0) {
            this.selectedSpec[spec.name] = spec.values[0];
          }
        });

        // 尝试从goodsDetail中获取SKU数据，如果没有则初始化模拟数据
        this.skuList = this.goodsDetail.skus || this.getMockSkuList();

        // 根据默认选择的规格查找对应的SKU
        this.findCurrentSku();
      }
    },

    // 获取模拟SKU数据（在实际项目中应该从API获取）
    getMockSkuList() {
      const mockSkus = [];
      // 根据规格组合生成模拟SKU数据
      if (this.goodsDetail && this.goodsDetail.spec) {
        const generateSkus = (specs, index = 0, currentSpec = {}) => {
          if (index >= specs.length) {
            // 为每个SKU组合生成不同的价格
            const basePrice = parseFloat(this.goodsDetail.price) || 100;
            const priceFactor =
              1 + Object.values(currentSpec).join("").length * 0.1; // 简单计算价格因子
            const price = (basePrice * priceFactor).toFixed(2);
            const skuModel = JSON.stringify(currentSpec);

            mockSkus.push({
              id: `sku_${Date.now()}_${mockSkus.length}`,
              goods_id: this.goodsDetail.id,
              price: price,
              stock: 100,
              sku_model: skuModel,
            });
            return;
          }

          const spec = specs[index];
          spec.values.forEach((value) => {
            currentSpec[spec.name] = value;
            generateSkus(specs, index + 1, { ...currentSpec });
          });
        };

        generateSkus(this.goodsDetail.spec);
      }
      return mockSkus;
    },

    // 根据当前选中的规格查找对应的SKU
    findCurrentSku() {
      if (this.skuList.length === 0) {
        this.currentSku = null;
        return;
      }

      // 遍历SKU列表，查找匹配当前规格的SKU
      for (const sku of this.skuList) {
        try {
          const skuSpec = JSON.parse(sku.sku_model);
          let isMatch = true;

          // 检查每个规格是否匹配
          for (const [key, value] of Object.entries(this.selectedSpec)) {
            if (skuSpec[key] !== value) {
              isMatch = false;
              break;
            }
          }

          if (isMatch) {
            this.currentSku = sku;
            return;
          }
        } catch (e) {
          console.error("解析SKU规格失败:", e);
        }
      }

      this.currentSku = null;
    },

    // 处理规格选择变化
    handleSpecChange(specName, specValue) {
      this.selectedSpec[specName] = specValue;
      this.findCurrentSku(); // 更新当前SKU
    },

    // 减少数量
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },

    // 增加数量
    increaseQuantity() {
      this.quantity++;
    },

    // 处理数量输入
    handleQuantityInput() {
      // 确保数量为数字且不小于1
      let num = parseInt(this.quantity);
      if (isNaN(num) || num < 1) {
        this.quantity = 1;
      } else if (num > 999) {
        this.quantity = 999;
        Message.warning("最多选择999件");
      } else {
        this.quantity = num;
      }
    },

    // 取整方法（将导入的函数添加到methods中）
    roundNumber(num, type) {
      return roundNumber(num, type);
    },

    // 获取当前价格
    getCurrentPrice() {
      // 如果有选中的SKU，使用SKU的价格，否则使用商品的基础价格
      if (this.currentSku && this.currentSku.price) {
        return parseFloat(this.currentSku.price);
      }
      return this.goodsDetail ? parseFloat(this.goodsDetail.price) : 0;
    },

    // 打开图片预览
    openImageModal(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.showPreview = true;
    },

    // 关闭图片预览
    closeImageModal() {
      this.showPreview = false;
    },

    // 切换主图
    changeMainImage(imageUrl, index, event) {
      if (event && event.target) {
        this.activeImageIndex = index;
        this.currentMainImage = imageUrl;
        this.previewImageUrl = imageUrl;
      }
    },

    // 在线咨询
    handleOnlineConsultation() {
      Message.success("正在连接客服，请稍候...");
    },

    // 加入购物车
    async handleAddToCart() {
      if (!this.goodsDetail) {
        Message.error("商品信息加载失败");
        return;
      }

      // 检查是否选择了规格（如果有规格）
      if (this.goodsDetail.spec && this.goodsDetail.spec.length > 0) {
        const missingSpecs = this.goodsDetail.spec.filter(
          (spec) => !this.selectedSpec[spec.name]
        );
        if (missingSpecs.length > 0) {
          Message.warning(
            `请选择${missingSpecs.map((s) => s.name).join("、")}`
          );
          return;
        }
      }

      // 格式化选中的规格文本
      let specText = "";
      if (this.goodsDetail.spec && this.goodsDetail.spec.length > 0) {
        specText = this.goodsDetail.spec
          .map((spec) => `${spec.name}: ${this.selectedSpec[spec.name]}`)
          .join(", ");
      }

      // 构建商品数据
      const cartItem = {
        sku_id: this.currentSku ? this.currentSku.id : this.goodsDetail.sku_id,
        name: this.goodsDetail.name,
        price: this.getCurrentPrice() || 0,
        quantity: this.quantity,
        thumbnail_url: this.goodsDetail.thumbnail_url || "",
        supplier_name: this.goodsDetail.supplier_name || "未知供应商",
        supplier_id: this.goodsDetail.supplier_id || "",
        short_description: this.goodsDetail.short_description || "",
        goods_id: this.goodsDetail.id,
        spec_text: specText,
      };

      try {
        // 直接调用API添加商品到购物车
        const response = await api.goods.addToCart(cartItem);

        // 显示成功提示
        Message.success(`成功加入购物车`);

        // 重置数量
        this.quantity = 1;
      } catch (error) {
        console.error("加入购物车失败:", error);
      }
    },

    // 立即租赁
    async handleRentNow() {
      // 先检查是否选择了规格
      if (this.goodsDetail.spec && this.goodsDetail.spec.length > 0) {
        const missingSpecs = this.goodsDetail.spec.filter(
          (spec) => !this.selectedSpec[spec.name]
        );
        if (missingSpecs.length > 0) {
          Message.warning(
            `请选择${missingSpecs.map((s) => s.name).join("、")}`
          );
          return;
        }
      }

      // 构建查询参数
      const queryParams = new URLSearchParams({
        goodsId: this.goodsDetail.id || 1,
        quantity: this.quantity,
        skuId: this.currentSku
          ? this.currentSku.id
          : this.goodsDetail.sku_id || "",
      });

      // 如果有选中的规格，添加到查询参数
      if (Object.keys(this.selectedSpec).length > 0) {
        queryParams.append("spec", JSON.stringify(this.selectedSpec));
      }

      this.$router.push(`/checkout?${queryParams.toString()}`);
    },
  },
  // 监听路由变化，重新加载商品详情
  watch: {
    "$route.params.id": {
      handler() {
        this.loadGoodsDetail();
      },
      immediate: false,
    },
  },
};
</script>

<style scoped>
/* 容器样式 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 0.3s ease-out;
}

.thumbnail.active {
  border-color: #2563eb !important;
}

body {
  padding-bottom: 80px;
}

#imageModal {
  backdrop-filter: blur(4px);
}

.dealnumber::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.dealnumber::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/GoodsDetail.vue